import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen grid place-items-center bg-sand text-ink-soft">Chargement…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};
